import { createGlobalStyle } from "styled-components";

export const GlobalStyle = createGlobalStyle`

#root{
    background-color:#5D5D5D;
    min-height:100vh;
    min-width:1440px;
}

`